import { styled } from "@mui/material";

const PREFIX = "Interests-Main";

export const classes = {
  root: `${PREFIX}-root`,
  banner: `${PREFIX}-banner`,
  onet: `${PREFIX}-onet`,
  onetlink: `${PREFIX}-onetlink`,
};

export const Item = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90vh",
  },
  [`& .${classes.banner}`]: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.secondary,
    width: "100%",
    maxWidth: "100%",
    padding: "20px 0px",
  },
  [`& .${classes.onet}`]: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "1600px",
  },
  [`& .${classes.onetlink}`]: {
    color: theme.palette.primary.contrast,
    textDecoration: "none",
    "&:visited": {
      color: theme.palette.primary.contrast,
    },
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
